<template>
  <div class="warning-panel" :class="{ 'is-severe': severe }">
    <ErrorIcon class="icon" />
    <div class="title-wrap">
      <slot name="title">
        <span class="title">{{ title }}</span>
      </slot>
    </div>
    <div class="message" style="margin-top: 8px;">
      <slot name="message">
        {{ msg }}
      </slot>
    </div>
  </div>
</template>

<script>
import ErrorIcon from "@/assets/svg/icon-form-error.svg";

export default {
  name: "WarningPanel",
  props: {
    title: String,
    msg: String,
    severe: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ErrorIcon,
  },
};
</script>

<style lang="scss" scoped>
.warning-panel {
  display: grid;
  grid-template-columns: min-content auto;
  grid-template-rows: repeat(2, auto);
  grid-column-gap: $spacing-small;

  background-color: $white;
  border: 2px solid $brand-orange;
  border-radius: $border-radius-small;
  box-shadow: $brand-box-shadow;

  padding: $spacing-xs $spacing-small;
  margin: $spacing-medium 0;

  font-size: 1.7rem;

  &.is-severe {
    color: $error;
    background-color: lighten($error, 70%);
    border: 2px solid $error;
  }

  .icon {
    width: 36px;
    fill: $error;

    grid-column: 1;
    grid-row: 1 / 3;
  }

  .title-wrap {
    align-self: end;
  }

  .title {
    text-align: start;
    font-weight: $font-bold;

    margin: 0;
    color: inherit;
  }
}
</style>
